import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'kion-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {

  @Input() withSlope = false;
  @Input() headline: string;
  @Input() text: string;
  @Input() backToHomeText: string;
  @Input() link: string;
  @Input() historyBack: boolean;

  constructor(private router: Router) { }

  backToLink(): void {
    if (this.historyBack) {
      window.history.back();
      return;
    }
    this.router.navigate(this.link.split('/')).then(() => { })
  }

}
